/**
 * Iconița de cookie Consentia (butonul fix din stânga jos, în shadow DOM-ul `#consentia-root`) urcă deasupra barei
 * sticky „Adaugă în coș” pe mobil, ca restul butoanelor plutitoare (`snippets/perdele-bara-sticky.liquid`).
 * Din afară, stilul nu ajunge în shadow DOM, dar variabilele CSS se moștenesc: aici se pune o singură regulă
 * care citește `--perdele-bara-sticky` (0 când bara nu e vizibilă). Butonul de redeschidere are clasa `ro`.
 */
const STIL = `
  button.ro {
    translate: 0 calc(-1 * var(--perdele-bara-sticky, 0px));
  }

  @media (prefers-reduced-motion: no-preference) {
    button.ro {
      transition: translate var(--animation-speed, 0.2s) var(--animation-easing, ease);
    }
  }
`;
const MARCAJ = 'data-perdele-bara-sticky';
/** Cât se așteaptă după Consentia; fără ea (sau fără consimțământ cerut) nu se mai urmărește pagina. */
const ASTEPTARE_MAXIMA_MS = 30000;

/** @param {ShadowRoot} radacina */
function puneStilul(radacina) {
  if (radacina.querySelector(`style[${MARCAJ}]`)) return;
  const stil = document.createElement('style');
  stil.setAttribute(MARCAJ, '');
  stil.textContent = STIL;
  radacina.append(stil);
}

/** Consentia își desenează shadow DOM-ul după încărcare și îl poate redesena: stilul se pune la loc. */
function urmareste() {
  const radacina = document.getElementById('consentia-root')?.shadowRoot;
  if (!radacina) return false;
  puneStilul(radacina);
  new MutationObserver(() => puneStilul(radacina)).observe(radacina, { childList: true });
  return true;
}

if (!urmareste()) {
  const asteapta = new MutationObserver(() => {
    if (urmareste()) asteapta.disconnect();
  });
  asteapta.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => asteapta.disconnect(), ASTEPTARE_MAXIMA_MS);
}
